import { defineProperty as _defineProperty, objectSpread2 as _objectSpread2, inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import { Button } from 'carbon-components-react';
import { ButtonKinds } from 'carbon-components-react/lib/prop-types/types';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { settings } from 'carbon-components';
import { FW_PREFIX } from '../../shared/constants/generalConstants.js';
import { IlIcon } from '../IlIcon/index.js';

var BUTTON_SIZE = {
  Small: 'small',
  Default: 'default'
};
var IlButton = /*#__PURE__*/function (_Component) {
  _inherits(IlButton, _Component);
  var _super = _createSuper(IlButton);
  function IlButton() {
    _classCallCheck(this, IlButton);
    return _super.apply(this, arguments);
  }
  _createClass(IlButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        kind = _this$props.kind,
        icon = _this$props.icon,
        ilRetro = _this$props.ilRetro,
        disabled = _this$props.disabled,
        iconFirst = _this$props.iconFirst,
        iconDescription = _this$props.iconDescription;
      var prefix = settings.prefix;
      if (ilRetro) {
        classNames('bx--btn--il-retro');
      }

      // Delete ilretro from props to avoid "passing true to non-boolean prop" error
      var clonedProps = _objectSpread2({}, this.props);
      delete clonedProps.ilRetro;
      return /*#__PURE__*/React__default.createElement(Button, _extends({}, clonedProps, {
        className: classNames(className, "".concat(FW_PREFIX, "__IlButton"), "".concat(prefix, "--btn"), "".concat(prefix, "--btn--il-").concat(kind), _defineProperty({}, "".concat(prefix, "--btn--il-Icon-tooltip-disable"), icon && !iconDescription)),
        testid: this.props.testid,
        disabled: disabled,
        "data-dismiss": this.props.dataDismiss
      }), icon && icon !== 'none' && iconFirst && /*#__PURE__*/React__default.createElement(IlIcon, {
        name: icon,
        className: "".concat(FW_PREFIX, "--btn__icon ").concat(FW_PREFIX, "-icon-").concat(icon, " icon-first")
      }), this.props.children, icon && icon !== 'none' && !iconFirst && /*#__PURE__*/React__default.createElement(IlIcon, {
        name: icon,
        className: "".concat(FW_PREFIX, "--btn__icon ").concat(FW_PREFIX, "-icon-").concat(icon)
      }));
    }
  }]);
  return IlButton;
}(Component);
_defineProperty(IlButton, "propTypes", _objectSpread2(_objectSpread2({}, Button.propTypes), {}, {
  kind: PropTypes.oneOf(ButtonKinds),
  size: PropTypes.oneOf(Object.values(BUTTON_SIZE)),
  ilRetro: PropTypes.bool
}));
_defineProperty(IlButton, "defaultProps", {
  size: 'default',
  kind: 'primary'
});

export { BUTTON_SIZE, IlButton };
